import { render, staticRenderFns } from "./DoiModal.vue?vue&type=template&id=05838570&"
import script from "./DoiModal.vue?vue&type=script&lang=js&"
export * from "./DoiModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports